module.exports = __webpack_public_path__ + "img/project_mapping.b8f8a03f.png";